export function useTouchDevice() {
  return matchMedia('(hover: none)').matches
}
